import React, { FC, forwardRef, RefAttributes } from 'react';

export interface CartProps {
  viewChangeComponent?: React.ReactNode;
  applyChangeComponent?: React.ReactNode;
  className?: string;
}

export const Cart: FC<CartProps & RefAttributes<HTMLDivElement>> = forwardRef(
  ({ viewChangeComponent, applyChangeComponent, className }, ref) => (
    <div ref={ref} className={`cart ${className}`}>
      <div className="cart-top">{viewChangeComponent}</div>
      <hr className="cart-hr" />
      <div className="cart-bottom flex-wrap">{applyChangeComponent}</div>
    </div>
  )
);

Cart.displayName = 'Cart';
export default Cart;
